import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import { createStyles, withStyles } from '@material-ui/core/styles';

const styles = createStyles({
  fields: {
    overflow: 'inherit'
  }
});

type Props = {
  classes: any,
  record: any
};

class PlacementPreviewButton extends Component<Props> {
  validExampleUrl = () => (
    this.props.record && this.props.record.example_url && this.props.record.example_url.includes('http')
  )

  formattedExampleUrl = () => {
    if (this.props.record.example_url.includes('?')) {
      return this.props.record.example_url + '&tmn-placement=' + this.props.record.code
    } else {
      return this.props.record.example_url + '?tmn-placement=' + this.props.record.code
    }
  }

  render() {
    return (
      <div>
        {this.validExampleUrl() &&
          <a href={this.formattedExampleUrl()} target="_blank" rel="noopener noreferrer">
            <Button color="primary" className={this.props.classes.fields}>Preview Placement</Button>
          </a>
        }
      </div>
    )
  }
};

export default withStyles(styles)(PlacementPreviewButton);



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Helpers/PlacementPreviewButton.tsx